export const CACHE_KEY_LIST_ACTOR_PROCESS = 'process-actors';
export const CACHE_KEY_ACTOR_PROCESS = 'actor-one';
export const CACHE_KEY_LIST_ACTOR_PROCESS_MODAL = 'process-actors-dialog';
export const DIALOG_NAMESPACE_EDIT_ACTION = 'dialog-namespace-edit-action';
